import React from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  Box,
  IconButton,
  useDisclosure,
  useBreakpointValue,
} from "@chakra-ui/react";

interface IButtonDropdown {
  popoverContent: React.ReactNode;
  disabled?: boolean;
}

const ButtonDropdown: React.FC<IButtonDropdown> = ({
  popoverContent,
  disabled,
}) => {
  const { onOpen, onClose, isOpen } = useDisclosure();

  // Detecta automaticamente se está no mobile
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Popover
      placement={isMobile ? "bottom-end" : "right-end"}
      isLazy
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      closeOnBlur
      closeOnEsc
      strategy={isMobile ? "fixed" : "absolute"}
      modifiers={
        isMobile
          ? [
              { name: "offset", options: { offset: [0, 6] } },
              { name: "preventOverflow", enabled: false },
              { name: "flip", enabled: false },
            ]
          : []
      }
    >
      <PopoverTrigger>
        <IconButton
          aria-label="menu"
          icon={
            <Box
              fontSize="20px"
              transform="rotate(90deg)"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              ⋮
            </Box>
          }
          size="sm"
          variant="ghost"
          isDisabled={disabled}
          display="inline-flex"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onOpen();
          }}
        />
      </PopoverTrigger>

      <PopoverContent
        width={isMobile ? "240px" : "200px"}
        boxShadow="lg"
        borderRadius="md"
        _focus={{ boxShadow: "lg" }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
        sx={
          isMobile
            ? {
                position: "fixed !important",
                right: "12px !important",
                zIndex: 999999,
              }
            : {}
        }
      >
        <PopoverArrow />
        <PopoverBody p={0}>{popoverContent}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ButtonDropdown;
